// TelcoTrack — BUDOVA building type (first workflow interaction).

export const BUDOVA_BUILDING_TYPES = ['PRIPOJENA', 'BABOVKA', 'ZAMITNUTA'] as const;
export type BudovaBuildingType = (typeof BUDOVA_BUILDING_TYPES)[number];

export const BUDOVA_BUILDING_TYPE_LABELS: Record<BudovaBuildingType, string> = {
  PRIPOJENA: 'Připojená',
  BABOVKA: 'Bábovka',
  ZAMITNUTA: 'Nerealizované',
};

export function isBudovaBuildingType(value: string | null | undefined): value is BudovaBuildingType {
  return (BUDOVA_BUILDING_TYPES as readonly string[]).includes((value ?? '').trim());
}

/** Výkres Akvizice: Podepsat → Připojená. */
export const AKVIZICE_DRAWING_SIGN_BUILDING_TYPE: BudovaBuildingType = 'PRIPOJENA';

/** Výkres Akvizice: reject action → Bábovka (not ZAMITNUTA type). */
export const AKVIZICE_DRAWING_REJECT_BUILDING_TYPE: BudovaBuildingType = 'BABOVKA';

/**
 * Hláška, když `canChangeBuildingType` zamkne změnu typu
 * (hotový VR / závrt / připravená bábovka). Odbočka a záfuk neblokují.
 */
export const AKVIZICE_DRAWING_BUILDING_TYPE_LOCKED_MESSAGE =
  'Typ budovy nelze změnit, protože na budově už je hotový vrt, závrt nebo připravená bábovka. Kontaktujte správce.';
